import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, withCtx as _withCtx, Fragment as _Fragment, vModelText as _vModelText, renderList as _renderList, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "Referral_Source",
  class: "row p-4 pb-0"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-2 d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Referral Information")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, " Use the filters below to narrow down physicians by city and/or state. To search for a physician, enter the physician's name or NPI in the respective search field. ")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "form-group col-12 d-flex flex-column" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Filters", -1 /* HOISTED */)
const _hoisted_5 = { class: "col-12 flex-row py-2 px-3 row g-0 mb-2" }
const _hoisted_6 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, " City ", -1 /* HOISTED */)
const _hoisted_8 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, " State ", -1 /* HOISTED */)
const _hoisted_10 = { class: "form-group col-12 d-flex flex-column" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("b", { class: "mb-2" }, "Search", -1 /* HOISTED */)
const _hoisted_12 = { class: "col-12 flex-row px-3 row g-0 mb-2 align-items-center" }
const _hoisted_13 = { class: "form-group card p-2 d-flex col-12 col-lg-6 pe-lg-3 flex-row" }
const _hoisted_14 = { class: "form-group col-lg-6 ms-3" }
const _hoisted_15 = { for: "referral-source" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Referring Physician ")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_18 = {
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary font-size-xs" }, null, -1 /* HOISTED */)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_22 = { class: "form-group col-lg-5 form-check custom-checkbox form-check-inline align-items-center justify-content-end" }
const _hoisted_23 = {
  class: "form-check-label flex-grow-0",
  for: "signing-plan-of-care"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, " Signing Plan of Care", -1 /* HOISTED */)
const _hoisted_25 = {
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary font-size-xs" }, null, -1 /* HOISTED */)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "form-group col-12 col-lg-1 text-center" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "OR")
], -1 /* HOISTED */)
const _hoisted_29 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, " NPI ", -1 /* HOISTED */)
const _hoisted_31 = { class: "form-group col-12 d-flex flex-column" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Face-to-Face Evaluation Information", -1 /* HOISTED */)
const _hoisted_33 = { class: "form-group p-2 col-12 col-lg-6 pe-lg-3 flex-row" }
const _hoisted_34 = { class: "col-12 col-lg-10 d-flex g-0" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", {
  class: "px-2",
  for: "evaluationna"
}, "N/A", -1 /* HOISTED */)
const _hoisted_36 = { class: "col-12 d-flex col-lg-10 mb-0 g-0" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", {
  class: "px-2",
  for: "evaluationdate"
}, "Date of face-to-face visit", -1 /* HOISTED */)
const _hoisted_38 = { class: "col-12 col-lg-10 d-flex g-0" }
const _hoisted_39 = {
  key: 0,
  class: "form-group offset-lg-1"
}
const _hoisted_40 = { class: "input-group date datepickerInput" }
const _hoisted_41 = ["value"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon d-flex input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ]),
  /*#__PURE__*/_createElementVNode("label", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
  ])
], -1 /* HOISTED */)
const _hoisted_43 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_44 = { class: "col-12 col-lg-10 d-flex g-0" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", {
  class: "px-2",
  for: "evaluationwithindays"
}, " Face-to-face to be completed within 30 days ", -1 /* HOISTED */)
const _hoisted_46 = { class: "form-group col-12 d-flex row" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-2 d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Certifying Physician Information")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, " Use the filters below to narrow down physicians by city and/or state. To search for a physician, enter the physician’s name or NPI in the respective search field. ")
], -1 /* HOISTED */)
const _hoisted_48 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_49 = { class: "form-check custom-checkbox form-check-inline ps-0" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", {
  for: "certifying-physician-filters",
  class: "card px-2 py-2 cursor-pointer"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1 text-secondary" }, "Hide Search Parameters")
], -1 /* HOISTED */)
const _hoisted_51 = { class: "col-12 d-flex flex-column" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Filters", -1 /* HOISTED */)
const _hoisted_53 = { class: "col-12 flex-row py-2 px-3 row g-0 mb-2" }
const _hoisted_54 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, " City ", -1 /* HOISTED */)
const _hoisted_56 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, " State ", -1 /* HOISTED */)
const _hoisted_58 = { class: "form-group col-12 d-flex flex-column" }
const _hoisted_59 = {
  key: 0,
  class: "me-2"
}
const _hoisted_60 = { class: "form-group card p-2 d-flex col-12 pe-lg-3 col-lg-8 flex-row form-check-inline align-items-center justify-content-between" }
const _hoisted_61 = { class: "form-group ps-3 col-lg-8" }
const _hoisted_62 = { for: "referral-source" }
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" Certifying Physician ")
const _hoisted_64 = {
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary font-size-xs" }, null, -1 /* HOISTED */)
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = { class: "form-check custom-checkbox form-check-inline" }
const _hoisted_68 = {
  class: "form-check-label mt-1",
  for: "referral-same-attending-physician"
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", { class: "me-1 mb-2" }, " Attending Physician ", -1 /* HOISTED */)
const _hoisted_70 = {
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_71 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary font-size-xs" }, null, -1 /* HOISTED */)
const _hoisted_72 = [
  _hoisted_71
]
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "form-group col-12 col-lg-1 text-center" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "OR")
], -1 /* HOISTED */)
const _hoisted_74 = { class: "form-group col-12 col-lg-3 pe-lg-3" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, " NPI ", -1 /* HOISTED */)
const _hoisted_76 = {
  key: 1,
  class: "form-group col-12 col-lg-3 pe-lg-3"
}
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "form-check custom-checkbox form-check-inline justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "checkbox",
    hidden: "",
    id: "certifying-physician-filters",
    class: "form-check-input au-target hidden"
  })
], -1 /* HOISTED */)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("label", {
  for: "certifying-physician-filters",
  class: "card px-2 py-2 cursor-pointer"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1 text-center text-secondary" }, " View More Search Parameters")
], -1 /* HOISTED */)
const _hoisted_79 = [
  _hoisted_77,
  _hoisted_78
]
const _hoisted_80 = { class: "col-12 ps-2 row g-0" }
const _hoisted_81 = { class: "form-group col-12 col-lg-6 pe-lg-2" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, " Name of Referral Source", -1 /* HOISTED */)
const _hoisted_83 = { class: "form-group col-12 col-lg-6 pe-lg-2" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("label", { for: "community-liaison" }, " Community Liaison ", -1 /* HOISTED */)
const _hoisted_85 = {
  key: 0,
  value: ""
}
const _hoisted_86 = {
  key: 1,
  value: '00000000-0000-0000-0000-000000000000'
}
const _hoisted_87 = ["value"]
const _hoisted_88 = { class: "form-group col-12 col-lg-6 pe-lg-2" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Facility Referral Source")
], -1 /* HOISTED */)
const _hoisted_90 = {
  key: 0,
  value: ""
}
const _hoisted_91 = {
  key: 1,
  value: '00000000-0000-0000-0000-000000000000'
}
const _hoisted_92 = ["value"]
const _hoisted_93 = { class: "form-group col-12 col-lg-6 pe-lg-2" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("label", { for: "internal-referral-source-name" }, " Internal Referral Source ", -1 /* HOISTED */)
const _hoisted_95 = {
  key: 0,
  value: ""
}
const _hoisted_96 = {
  key: 1,
  value: '00000000-0000-0000-0000-000000000000'
}
const _hoisted_97 = ["value"]
const _hoisted_98 = { class: "form-group col-12 col-lg-6 pe-lg-2" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("label", { for: "admission-source-name" }, [
  /*#__PURE__*/_createTextVNode(" Admission Source "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "--Select Option--", -1 /* HOISTED */)
const _hoisted_101 = ["value"]
const _hoisted_102 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_103 = { class: "form-group col-12 col-lg-6 pe-lg-2" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("label", { for: "assign-to-clinical-manager" }, " Assign To Clinical Manager", -1 /* HOISTED */)
const _hoisted_105 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "--Select Option--", -1 /* HOISTED */)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("option", { value: '00000000-0000-0000-0000-000000000000' }, "--Select Option--", -1 /* HOISTED */)
const _hoisted_107 = ["value"]
const _hoisted_108 = { class: "form-group col-12 col-lg-6 pe-lg-2" }
const _hoisted_109 = { for: "type-of-inpatient-code" }
const _hoisted_110 = /*#__PURE__*/_createTextVNode("Type of Inpatient Admission/Visit Code ")
const _hoisted_111 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_112 = {
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_113 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary font-size-xs" }, null, -1 /* HOISTED */)
const _hoisted_114 = [
  _hoisted_113
]
const _hoisted_115 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "--Select Option--", -1 /* HOISTED */)
const _hoisted_116 = ["value"]
const _hoisted_117 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_118 = { class: "form-group col-12 col-lg-6 pe-lg-2" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("label", { for: "referral-date" }, [
  /*#__PURE__*/_createTextVNode(" Referral Date "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_120 = { class: "input-group date datepickerInput" }
const _hoisted_121 = ["value"]
const _hoisted_122 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_123 = {
  key: 0,
  class: "field-invalid"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_custom_popover = _resolveDirective("custom-popover")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Referral Source",
    "full-height": false,
    "application-id": _ctx.referral?.application
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("section", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_TypeaheadInput, {
                getData: _ctx.getReferringPhysicianListItem,
                value: _ctx.referringPhysicianFilters.city,
                onValueChanged: _ctx.referringPhysicianFiltersCity,
                "results-limit": 1,
                "init-value": _ctx.referringPhysicianFilters.city,
                itemName: "city",
                placeholder: "Select City"
              }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "init-value"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_TypeaheadInput, {
                getData: _ctx.getReferringPhysicianListItem,
                value: _ctx.referringPhysicianFilters.state,
                onValueChanged: _ctx.referringPhysicianFiltersState,
                "init-value": _ctx.referringPhysicianFilters.state,
                "results-limit": 2,
                itemName: "state",
                placeholder: "Select State"
              }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "init-value"])
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("section", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, [
                  _hoisted_16,
                  _hoisted_17,
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_18, _hoisted_20)), [
                    [_directive_custom_popover, { content: _ctx.sanitizeMarkup(_ctx.refPhysicianTooltip) }]
                  ])
                ]),
                _createVNode(_component_TypeaheadInput, {
                  getData: _ctx.getReferringPhysicianList,
                  value: _ctx.referringPhysicianName,
                  onValueChanged: _ctx.referringPhysicianNameChange,
                  placeholder: "Search by Name",
                  onBlur: _ctx.v$.referringPhysicianName.$touch,
                  class: _normalizeClass(`${!_ctx.v$.referringPhysicianName.$error ? '' : 'field-invalid'}`)
                }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "onBlur", "class"]),
                (_ctx.v$.referringPhysicianName.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Referring Physician is required."))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "signing-plan-of-care",
                  class: "form-check-input au-target",
                  onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signingPOCChanged())),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.referral.ReferralExtension.IsSigningPlanOfCare) = $event))
                }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.referral.ReferralExtension.IsSigningPlanOfCare]
                ]),
                _createElementVNode("label", _hoisted_23, [
                  _hoisted_24,
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_25, _hoisted_27)), [
                    [_directive_custom_popover, { content: _ctx.sanitizeMarkup(_ctx.signingPOCTooltip) }]
                  ])
                ])
              ])
            ]),
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createVNode(_component_TypeaheadInput, {
                getData: _ctx.getReferringPhysicianListItem,
                value: _ctx.referringPhysicianFilters.npi,
                onValueChanged: _ctx.referringPhysicianFiltersNpiChange,
                "results-limit": 3,
                itemName: "npi",
                "key-updated": _ctx.npiChanged('referring'),
                placeholder: "Search by NPI"
              }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "key-updated"])
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.faceToFaceEvaluation) = $event)),
                value: null,
                name: "face-to-face-evaluation",
                type: "radio",
                "au-target-id": "791",
                id: "evaluationna"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelRadio, _ctx.faceToFaceEvaluation]
              ]),
              _hoisted_35
            ]),
            _createElementVNode("div", _hoisted_36, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.faceToFaceEvaluation) = $event)),
                value: true,
                name: "face-to-face-evaluation",
                type: "radio",
                "au-target-id": "791",
                id: "evaluationdate"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelRadio, _ctx.faceToFaceEvaluation]
              ]),
              _hoisted_37
            ]),
            _createElementVNode("div", _hoisted_38, [
              (_ctx.faceToFaceEvaluation)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("input", {
                            type: "text",
                            name: "evaluation-date",
                            class: _normalizeClass(["form-control", `${
                                                !_ctx.v$.referral.ReferralExtension.DateOfFaceToFaceVisit.$error
                                                    ? ''
                                                    : 'field-invalid'
                                            }`]),
                            placeholder: "MM/DD/YYYY",
                            value: _ctx.formatDateInput(_ctx.referral.ReferralExtension.DateOfFaceToFaceVisit),
                            onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args))),
                            autocomplete: "off",
                            onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.ReferralExtension.DateOfFaceToFaceVisit.$touch && _ctx.v$.referral.ReferralExtension.DateOfFaceToFaceVisit.$touch(...args)))
                          }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_41),
                          _hoisted_42,
                          (_ctx.v$.referral.ReferralExtension.DateOfFaceToFaceVisit.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_43, "Date of Face-to-Face Visit is required."))
                            : _createCommentVNode("v-if", true)
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["getDate"])
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_44, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.faceToFaceEvaluation) = $event)),
                value: false,
                name: "face-to-face-evaluation",
                type: "radio",
                "au-target-id": "791",
                id: "evaluationwithindays"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelRadio, _ctx.faceToFaceEvaluation]
              ]),
              _hoisted_45
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_46, [
          (_ctx.showCertifyPhysicianFilters)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_47,
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      hidden: "",
                      id: "certifying-physician-filters",
                      class: "form-check-input au-target hidden",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showCertifyPhysicianFilters) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelCheckbox, _ctx.showCertifyPhysicianFilters]
                    ]),
                    _hoisted_50
                  ])
                ]),
                _createElementVNode("section", _hoisted_51, [
                  _hoisted_52,
                  _createElementVNode("section", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _hoisted_55,
                      _createVNode(_component_TypeaheadInput, {
                        getData: _ctx.getCertifyingPhysicianListItem,
                        value: _ctx.certifyingPhysicianFilters.city,
                        onValueChanged: _ctx.certifyingPhysicianFiltersCityChange,
                        "init-value": _ctx.certifyingPhysicianFilters.city,
                        itemName: "city",
                        placeholder: "Select City"
                      }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "init-value"])
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _hoisted_57,
                      _createVNode(_component_TypeaheadInput, {
                        getData: _ctx.getCertifyingPhysicianListItem,
                        value: _ctx.certifyingPhysicianFilters.state,
                        onValueChanged: _ctx.certifyingPhysicianFiltersStateChange,
                        "init-value": _ctx.certifyingPhysicianFilters.state,
                        itemName: "state",
                        placeholder: "Select State"
                      }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "init-value"])
                    ])
                  ])
                ])
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("section", _hoisted_58, [
            (_ctx.showCertifyPhysicianFilters)
              ? (_openBlock(), _createElementBlock("b", _hoisted_59, "Search"))
              : _createCommentVNode("v-if", true),
            _createElementVNode("section", {
              class: _normalizeClass(["flex-row row g-0 mb-2 align-items-center", _ctx.showCertifyPhysicianFilters && 'col-12'])
            }, [
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("label", _hoisted_62, [
                    _hoisted_63,
                    _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_64, _hoisted_66)), [
                      [_directive_custom_popover, { content: _ctx.sanitizeMarkup(_ctx.certifyingPhysicianTooltip) }]
                    ])
                  ]),
                  _createVNode(_component_TypeaheadInput, {
                    getData: _ctx.getCertifyingPhysicianList,
                    value: _ctx.certifyingPhysicianName,
                    onValueChanged: _ctx.certifyingPhysicianNameChange,
                    placeholder: "Enter Certifying Physician"
                  }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged"])
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "referral-same-attending-physician",
                    class: "form-check-input mt-2",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.referral.ReferralExtension.IsPrimaryCarePhysician) = $event)),
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.IsPrimaryCarePhysicianChange()))
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelCheckbox, _ctx.referral.ReferralExtension.IsPrimaryCarePhysician]
                  ]),
                  _createElementVNode("label", _hoisted_68, [
                    _hoisted_69,
                    _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_70, _hoisted_72)), [
                      [_directive_custom_popover, { content: _ctx.sanitizeMarkup(_ctx.attendingPhysicianTooltip) }]
                    ])
                  ])
                ])
              ]),
              (_ctx.showCertifyPhysicianFilters)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_73,
                    _createElementVNode("div", _hoisted_74, [
                      _hoisted_75,
                      _createVNode(_component_TypeaheadInput, {
                        getData: _ctx.getCertifyingPhysicianListItem,
                        value: _ctx.certifyingPhysicianFilters.npi,
                        valueChanged: _ctx.certifyingPhysicianFiltersNpiChange,
                        itemName: "npi",
                        placeholder: "Search By NPI",
                        "results-limit": 3,
                        "key-updated": _ctx.npiChanged('certifying')
                      }, null, 8 /* PROPS */, ["getData", "value", "valueChanged", "key-updated"])
                    ])
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              (!_ctx.showCertifyPhysicianFilters)
                ? (_openBlock(), _createElementBlock("div", _hoisted_76, _hoisted_79))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */)
          ]),
          _createElementVNode("section", _hoisted_80, [
            _createElementVNode("div", _hoisted_81, [
              _hoisted_82,
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                maxlength: "50",
                type: "text",
                placeholder: "Enter Name of Referral Source",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.referral.Referral.OtherReferralSource) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.referral.Referral.OtherReferralSource]
              ])
            ]),
            _createElementVNode("div", _hoisted_83, [
              _hoisted_84,
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.referral.Referral.CommunityLiaison) = $event))
              }, [
                (!_ctx.isEditing)
                  ? (_openBlock(), _createElementBlock("option", _hoisted_85, "--Select Option--"))
                  : (_openBlock(), _createElementBlock("option", _hoisted_86, " --Select Option-- ")),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions.communityLiaison, (cmtLiaison, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: index,
                    value: cmtLiaison.value
                  }, _toDisplayString(cmtLiaison.text), 9 /* TEXT, PROPS */, _hoisted_87))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, _ctx.referral.Referral.CommunityLiaison]
              ])
            ]),
            _createElementVNode("div", _hoisted_88, [
              _hoisted_89,
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.referral.Referral.FacilitySource) = $event))
              }, [
                (!_ctx.isEditing)
                  ? (_openBlock(), _createElementBlock("option", _hoisted_90, "--Select Option--"))
                  : (_openBlock(), _createElementBlock("option", _hoisted_91, " --Select Option-- ")),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions.facilitySource, (rflOption, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: index,
                    value: rflOption.value
                  }, _toDisplayString(rflOption.text), 9 /* TEXT, PROPS */, _hoisted_92))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, _ctx.referral.Referral.FacilitySource]
              ])
            ]),
            _createElementVNode("div", _hoisted_93, [
              _hoisted_94,
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.referral.Referral.InternalReferral) = $event))
              }, [
                (!_ctx.isEditing)
                  ? (_openBlock(), _createElementBlock("option", _hoisted_95, "--Select Option--"))
                  : (_openBlock(), _createElementBlock("option", _hoisted_96, " --Select Option-- ")),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions.internalReferral, (intrlRef, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: index,
                    value: intrlRef.value
                  }, _toDisplayString(intrlRef.text), 9 /* TEXT, PROPS */, _hoisted_97))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, _ctx.referral.Referral.InternalReferral]
              ])
            ]),
            _createElementVNode("div", _hoisted_98, [
              _hoisted_99,
              _withDirectives(_createElementVNode("select", {
                class: _normalizeClass(["form-select", `${!_ctx.v$.referral.Referral.AdmissionSource.$error ? '' : 'field-invalid'}`]),
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.referral.Referral.AdmissionSource) = $event)),
                onBlur: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Referral.AdmissionSource.$touch && _ctx.v$.referral.Referral.AdmissionSource.$touch(...args)))
              }, [
                _hoisted_100,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions?.admissionSource, (admSource, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: index,
                    value: admSource.value
                  }, _toDisplayString(admSource.text), 9 /* TEXT, PROPS */, _hoisted_101))
                }), 128 /* KEYED_FRAGMENT */))
              ], 34 /* CLASS, HYDRATE_EVENTS */), [
                [_vModelSelect, _ctx.referral.Referral.AdmissionSource]
              ]),
              (_ctx.v$.referral.Referral.AdmissionSource.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_102, "Admission Source is required."))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_103, [
              _hoisted_104,
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.referral.Referral.ClinicalManagerAssigned) = $event))
              }, [
                _hoisted_105,
                _hoisted_106,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions.clinicalManager, (clinMngr, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: index,
                    value: clinMngr.value
                  }, _toDisplayString(clinMngr.text), 9 /* TEXT, PROPS */, _hoisted_107))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, _ctx.referral.Referral.ClinicalManagerAssigned]
              ])
            ]),
            _createElementVNode("div", _hoisted_108, [
              _createElementVNode("label", _hoisted_109, [
                _hoisted_110,
                _hoisted_111,
                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_112, _hoisted_114)), [
                  [_directive_custom_popover, { content: _ctx.sanitizeMarkup(_ctx.inpatientCodeTooltip) }]
                ])
              ]),
              _withDirectives(_createElementVNode("select", {
                class: _normalizeClass(["form-select", `${
                                    !_ctx.v$.referral.Referral.AdditionalBillingInfo.AdmissionType.$error
                                        ? ''
                                        : 'field-invalid'
                                }`]),
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.referral.Referral.AdditionalBillingInfo.AdmissionType) = $event)),
                onBlur: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Referral.AdditionalBillingInfo.AdmissionType.$touch && _ctx.v$.referral.Referral.AdditionalBillingInfo.AdmissionType.$touch(...args)))
              }, [
                _hoisted_115,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions.admissionType, (admType, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: index,
                    value: admType.value
                  }, _toDisplayString(admType.text), 9 /* TEXT, PROPS */, _hoisted_116))
                }), 128 /* KEYED_FRAGMENT */))
              ], 34 /* CLASS, HYDRATE_EVENTS */), [
                [_vModelSelect, _ctx.referral.Referral.AdditionalBillingInfo.AdmissionType]
              ]),
              (_ctx.v$.referral.Referral.AdditionalBillingInfo.AdmissionType.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_117, "Admission Type is required."))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_118, [
              _hoisted_119,
              _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_120, [
                    _createElementVNode("input", {
                      type: "text",
                      name: "referral-date",
                      class: _normalizeClass(["form-control", `${!_ctx.v$.referral.Referral.ReferralDate.$error ? '' : 'field-invalid'}`]),
                      placeholder: "MM/DD/YYYY",
                      value: _ctx.formatDateInput(_ctx.referral.Referral.ReferralDate),
                      onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args))),
                      autocomplete: "off",
                      onBlur: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Referral.ReferralDate.$touch && _ctx.v$.referral.Referral.ReferralDate.$touch(...args)))
                    }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_121),
                    _hoisted_122,
                    (_ctx.v$.referral.Referral.ReferralDate.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_123, "Referral Date is required."))
                      : _createCommentVNode("v-if", true)
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["getDate"])
            ])
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}